/**
 * Resolve static lab files (wavetables, soundfonts) relative to the current page.
 * Absolute `/assets/...` breaks subdirectory deploys and `file://` opens of dist-adam.
 */
export function labAssetsBaseUrl(): string {
  if (typeof window === "undefined") {
    return "/assets/";
  }
  return new URL("assets/", window.location.href).href;
}

/** `relativePath` is under assets/ (e.g. `wavetables/Foo/Bar.wav`). */
export function labAssetUrl(relativePath: string): string {
  const cleaned = relativePath.replace(/^\/+/, "").replace(/^assets\//, "");
  const encoded = cleaned.split("/").map(encodeURIComponent).join("/");
  return new URL(encoded, labAssetsBaseUrl()).href;
}

export function labWorkletUrl(): string {
  if (typeof window === "undefined") {
    return "/curva-audio-worklet.js";
  }
  return new URL("curva-audio-worklet.js", window.location.href).href;
}

/** Dedicated Worker that runs the music PatternPlayer off the main thread. */
export function labSchedulerWorkerUrl(): string {
  if (typeof window === "undefined") {
    return "/curva-audio-scheduler.js";
  }
  return new URL("curva-audio-scheduler.js", window.location.href).href;
}
